import axios from '@/util/request';


export function getUserInfo(parameter) {
  //用户管理-查询用户列表
  return axios({
    url: '/admin/user/pageIms',
    method: 'get',
    params:parameter,
  })
}

export function getCheckInfo(id) {
  //用户管理-待审核用户
  return axios({
    url: '/admin/user/Verify/' + id,
    method: 'get',
  })
}

export function createUser(parameter){
  //用户管理-创建用户(后台用户)
  return axios({
    url:'/admin/user',
    method:'post',
    data:parameter
  })
}

export function delUser(id){
  //用户管理-删除用户
  return axios({
    url:'/admin/user/delete/' + id,
    method:'DELETE',
  })
}

export function updateUser(parameter){
  //用户管理-编辑用户
  return axios({
    url:'/admin/user/updateUserIms',
    method:'put',
    data:parameter
  })
}
export function updatePasw(parameter){
  //密码修改
  return axios({
    url:'/admin/user/updatePasswordIms',
    method:'put',
    params:parameter
  })
}
export function setViewStatus(parameter){
  //设置视图状态
  return axios({
    url:'/admin/user/setViewStatus',
    method:'get',
    params:parameter
  })
}



// WEBPACK FOOTER //
// ./src/api/userApi.js